"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

function retryMiddleware(options) {
  var _this = this;

  return function (next) {
    return function (args) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
          return [2
          /*return*/
          , options.retryStrategy.retry(next, args)];
        });
      });
    };
  };
}

exports.retryMiddleware = retryMiddleware;
exports.retryMiddlewareOptions = {
  name: "retryMiddleware",
  tags: ["RETRY"],
  step: "finalizeRequest",
  priority: "high"
};

exports.getRetryPlugin = function (options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      if (options.maxRetries > 0) {
        clientStack.add(retryMiddleware(options), exports.retryMiddlewareOptions);
      }
    }
  };
};